import React from "react";
import { ButtonsDiv, ConfirmationHeader, ConfirmationTextBody, ModalWrapper } from "./style";
import { Button } from "../../../../common/Button";

type Props = {
    newAccountType: string;
    onCancel: () => void;
    onSubmit: () => void;
}

export default function AccountTypeConfirmationModal({ newAccountType, onCancel, onSubmit }: Props) {
    const headerAction = newAccountType === 'primary' ? 'Make account primary' : 'Make account secondary'
    const bodyText = newAccountType === 'primary' ? 'Are you sure you want to set this as your primary account? This will replace your current primary account.' : 'Are you sure you want to change this to a secondary account?'
    return (
        <ModalWrapper>
            <ConfirmationHeader>
                {headerAction}
            </ConfirmationHeader>
            <ConfirmationTextBody>
                {bodyText}
            </ConfirmationTextBody>
            <ButtonsDiv>
                <Button
                    label="Yes"
                    type="button"
                    theme="secondary"
                    height="48px"
                    fontSize="14px"
                    onClick={onSubmit}
                />
                <Button
                    label="No"
                    type="button"
                    theme="alternate"
                    height="48px"
                    fontSize="14px"
                    onClick={onCancel}
                />
            </ButtonsDiv>

        </ModalWrapper>
    )
}